// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606230038/js/" + chunkId + "." + {"44":"c864492c","225":"ce7dc404","481":"e6dc62e1","486":"389c1209","770":"731f425b"}[chunkId] + ".0.0693698105937749.chunk.js";
};